import { DialogMessageRole, MessageType, type DialogMessage } from '../types/chat';

type YmParams = Record<string, string | number | boolean>;

type YmFunction = (
  counterId: number,
  method: 'reachGoal',
  goalName: string,
  params?: YmParams,
  cv?: () => void,
) => void;

declare global {
  interface Window {
    ym?: YmFunction;
    Ya?: {
      _metrika?: {
        counters?: Record<string, unknown>;
      };
    };
  }
}

export function reachYMGoal(goalName: YmGoal, params?: YmParams): void {
  if (typeof window === 'undefined') return;

  const counters = window.Ya?._metrika?.counters;
  if (!counters || typeof counters !== 'object') return;

  Object.keys(counters).forEach((key) => {
    // ключ вида "106877907:0"
    const counterId = Number(key.split(':')[0]);

    if (!Number.isFinite(counterId)) return;

    try {
      if (!window.ym) return;
      window.ym(counterId, 'reachGoal', goalName, params, () =>
        console.log(`Создана цель ${goalName} для счётчика ${counterId}`),
      );
    } catch {
      // игнорируем ошибку конкретного счётчика
    }
  });
}

export const checkYmGoalsOnMessageSend = (
  messageText: string,
  messageType: MessageType,
  currentMessages: DialogMessage[],

  continuePreviousDialog: boolean,
  isContinuePrevDialogYmGoalSent: boolean,
  onContinuePrevDialogYmGoalSent: () => void,
) => {
  if (messageText === '/start') {
    reachYMGoal(YmGoal.nlab_voice_dialog_started);
    return;
  }

  const userMessages = currentMessages.filter((m) => m.role === DialogMessageRole.USER);
  const isFirstUserMessage =
    !userMessages.length || (userMessages.length === 1 && userMessages[0].message === '/start');

  if (isFirstUserMessage) {
    reachYMGoal(YmGoal.nlab_user_first_message_sent);
  }

  const lastNotServiceMessage = currentMessages
    .filter((m) => m.role !== DialogMessageRole.SERVICE)
    .at(-1);
  const isSwitchedToTextMode =
    lastNotServiceMessage?.type === MessageType.VOICE && messageType === MessageType.TEXT;
  const isSwitchedToVoiceMode =
    lastNotServiceMessage?.type === MessageType.TEXT && messageType === MessageType.VOICE;

  if (isSwitchedToTextMode) {
    reachYMGoal(YmGoal.nlab_switched_to_text_mode);
  }

  if (isSwitchedToVoiceMode) {
    reachYMGoal(YmGoal.nlab_switched_to_voice_mode);
  }

  if (continuePreviousDialog && !isContinuePrevDialogYmGoalSent) {
    reachYMGoal(YmGoal.nlab_user_returned_to_dialog);
    onContinuePrevDialogYmGoalSent();
  }
};

export enum YmGoal {
  nlab_text_dialog_started = 'nlab_text_dialog_started',
  nlab_voice_dialog_started = 'nlab_voice_dialog_started',
  nlab_user_first_message_sent = 'nlab_user_first_message_sent',
  nlab_switched_to_text_mode = 'nlab_switched_to_text_mode',
  nlab_switched_to_voice_mode = 'nlab_switched_to_voice_mode',
  nlab_user_returned_to_dialog = 'nlab_user_returned_to_dialog',

  nlab_operator_requested = 'nlab_operator_requested',
  // nlab_operator_joined_dialog = 'nlab_operator_joined_dialog',

  nlab_supervisor_joined_dialog = 'nlab_supervisor_joined_dialog',
}
